import {
  IFeatureExternalLinkSectionQuery,
  useFeatureExternalLinkSectionQuery,
} from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureExternalLinkValue {
  featureExternalLinkLoading: boolean;
  featureExternalLink: IFeatureExternalLinkSectionQuery['FeatureExternalLinkSection'];
}

export const useFeatureExternalLink = (): IUseFeatureExternalLinkValue => {
  const { featureExternalLinkId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureExternalLinkSectionQuery({
    variables: { featureExternalLinkId },
    skip: !featureExternalLinkId,
  });

  const featureExternalLinkLoading = featureIdsLoading || loading;
  const featureExternalLink = data?.FeatureExternalLinkSection ?? null;

  return {
    featureExternalLinkLoading,
    featureExternalLink,
  };
};
